import { ScriptSkill } from '../types';

type Translate = (key: string, options?: Record<string, unknown>) => string;

export interface ScriptRewritePayloadFields {
  enableScriptNormalization: boolean;
  scriptSkillId?: string;
  scriptSkillValues?: Record<string, string>;
}

// 选了技能即开启改写;未选则不改写,且不发送技能字段。
export const buildCreateScriptRewriteFields = (
  scriptSkillId: string,
  scriptSkillValues: Record<string, string>,
): ScriptRewritePayloadFields => ({
  enableScriptNormalization: !!scriptSkillId,
  scriptSkillId: scriptSkillId || undefined,
  scriptSkillValues: scriptSkillId ? scriptSkillValues : undefined,
});

// 选了技能但必填变量缺失 → 返回错误文案;未选或齐全 → null。
export const validateCreateScriptRewrite = (
  scriptSkillId: string,
  scriptSkills: ScriptSkill[],
  scriptSkillValues: Record<string, string>,
  t: Translate,
): string | null => {
  if (!scriptSkillId) {
    return null;
  }
  const skill = scriptSkills.find(s => s.id === scriptSkillId);
  const missing = (skill?.variables || []).filter(
    v => v.required && !scriptSkillValues[v.key],
  );
  if (missing.length > 0) {
    return t('alert.missingScriptParams', { params: missing.map(v => v.label).join('、') });
  }
  return null;
};
